module.exports = __webpack_public_path__ + "static/media/jonesengineering.d85eae72.png";